module.exports = __webpack_public_path__ + "img/gift_2.ae13f895.jpg";